const SAUDI_TZ = 'Asia/Riyadh';

export function formatTimeSaudi(d) {
  if (!d) return '—';
  const date = new Date(d);
  return new Intl.DateTimeFormat('en-US', {
    timeZone: SAUDI_TZ,
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);
}

export function formatDateTimeSaudi(d) {
  if (!d) return '—';
  const date = new Date(d);
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: SAUDI_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date);

  const get = (type) => parts.find((p) => p.type === type)?.value || '';
  // en-GB gives day/month/year with separators; we output "DD / MM / YYYY HH:MM AM/PM"
  return `${get('day')} / ${get('month')} / ${get('year')} ${get('hour')}:${get('minute')} ${get('dayPeriod')}`;
}

export function getSaudiMinutesNow(now = new Date()) {
  // Convert to Saudi "wall clock" minutes using a fixed +3 offset.
  const saudiMs = now.getTime() + 3 * 60 * 60 * 1000;
  const saudi = new Date(saudiMs);
  return saudi.getUTCHours() * 60 + saudi.getUTCMinutes();
}

